<template>
  <ToolbarContainer>
    <template v-slot:toolbar>
      <BannerController
        v-if="bannerContent"
        :bannerContent="bannerContent"
      />
      <TabBar
        :class="$style.tabContainer"
      >
        <template #tabs>
          <Tabs
            :activeTab="activeTab"
            :tabs="tabs"
          />
        </template>
      </TabBar>
    </template>
    <template v-slot:body>
      <div
        :class="$style.body"
      >
        <slot />
      </div>
    </template>
  </ToolbarContainer>
</template>

<script>
import {
  TabBar,
  Tabs,
  ToolbarContainer,
  Types,
} from '@jumpcloud/ui-components';
import BannerController from 'client/components/ViewportBanner/BannerController.vue';
import BannerType from 'client/components/ViewportBanner/BannerType';

const { TabItem } = Types;

export default {
  name: 'PageTabs',

  components: {
    BannerController,
    TabBar,
    Tabs,
    ToolbarContainer,
  },

  props: {
    bannerContent: {
      type: BannerType,
      default: null,
    },
    tabConfig: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    activeTab() {
      const { matched, name } = this.$route;
      const activeTab = matched.length > 0 ? matched[1].name : name;

      return activeTab;
    },

    tabs() {
      return this.tabConfig.map((tab) => {
        const { name } = tab;
        return TabItem({
          key: name,
          label: tab.label,
          to: { name },
        });
      });
    },
  },
};
</script>

<style module>
  .tabContainer {
    margin-top: var(--jc-spacer);
    padding: 0 var(--jc-spacer);
  }

  .body {
    --sidebar-width: 18rem;

    background: var(--jcWhite);
    min-height: 0;
    min-width: 0;
  }
</style>
